const kn = {
  getHelp: {
    title: 'ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ ಪಡೆಯಿರಿ',
    subtitle: 'ನಿಮಗೆ ಸಹಾಯ ಬೇಕೆ? ನಮ್ಮ ತಂಡವು ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ಇಲ್ಲಿ ಇದೆ. ಫೋನ್, ಇಮೇಲ್ ಅಥವಾ ಲೈವ್ ಚಾಟ್ ಮೂಲಕ ಸಂಪರ್ಕಿಸಿ, ಅಥವಾ ಕೆಳಗಿನ ನಮ್ಮ ಎಫ್‌ಎಕ್ಸ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ.',
    contactInfo: 'ಸಂಪರ್ಕ ಮಾಹಿತಿ',
    faq: 'ಪದೇಪದೇ ಕೇಳುವ ಪ್ರಶ್ನೆಗಳು',
    faqSubtitle: 'ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಗಳನ್ನು ಹುಡುಕಿ',
    emergency: 'ತುರ್ತು',
    emergencyDesc: 'ತಕ್ಷಣದ ಸುರಕ್ಷತಾ ಚಿಂತೆಗಳಿಗೆ',
    support: 'ಬೆಂಬಲ',
    supportDesc: 'ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳು ಮತ್ತು ಸಹಾಯ',
    technical: 'ತಾಂತ್ರಿಕ',
    technicalDesc: 'ಆಪ್ ಮತ್ತು ವೆಬ್‌ಸೈಟ್ ಸಮಸ್ಯೆಗಳು',
    phone: 'ಫೋನ್',
    email: 'ಇಮೇಲ್',
    chat: 'ಲೈವ್ ಚಾಟ್',
    available: '24/7 ಲಭ್ಯವಿದೆ',
    responseTime: '2 ಗಂಟೆಗಳಲ್ಲಿ ಪ್ರತಿಕ್ರಿಯೆ',
    responseTimeLong: '24 ಗಂಟೆಗಳಲ್ಲಿ ಪ್ರತಿಕ್ರಿಯೆ',
  },
  myIssues: {
    title: 'ನನ್ನ ಸಮಸ್ಯೆಗಳು ಮತ್ತು ದೂರುಗಳು',
    subtitle: 'ನೀವು ವರದಿ ಮಾಡಿದ ಸಮಸ್ಯೆಗಳು ಮತ್ತು ದೂರುಗಳ ಸ್ಥಿತಿಯನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ. ತುರ್ತು ಸಹಾಯಕ್ಕಾಗಿ, ದಯವಿಟ್ಟು ಸಹಾಯ ಪಡೆಯಿರಿ ವಿಭಾಗವನ್ನು ಬಳಸಿ.',
    noIssues: 'ಯಾವುದೇ ದೂರುಗಳು ಅಥವಾ ಸಮಸ್ಯೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
    noIssuesDesc: 'ನಿಮಗೆ ಸಹಾಯ ಬೇಕಾದರೆ, ದಯವಿಟ್ಟು ಸಹಾಯ ಪಡೆಯಿರಿ ವಿಭಾಗವನ್ನು ಬಳಸಿ ಅಥವಾ ಹೊಸ ಸಮಸ್ಯೆಯನ್ನು ವರದಿ ಮಾಡಿ.',
    issueId: 'ಸಮಸ್ಯೆ ಐಡಿ',
    priority: 'ಪ್ರಾಮುಖ್ಯತೆ',
    status: 'ಸ್ಥಿತಿ',
    subject: 'ವಿಷಯ',
    type: 'ಪ್ರಕಾರ',
    filedOn: 'ದಾಖಲಿಸಲಾಗಿದೆ',
    inProgress: 'ಪ್ರಗತಿಯಲ್ಲಿ',
    resolved: 'ಪರಿಹರಿಸಲಾಗಿದೆ',
    closed: 'ಮುಚ್ಚಲಾಗಿದೆ',
    high: 'ಹೆಚ್ಚು',
    medium: 'ಮಧ್ಯಮ',
    low: 'ಕಡಿಮೆ',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    error: 'ಸಮಸ್ಯೆಗಳನ್ನು ಲೋಡ್ ಮಾಡುವಲ್ಲಿ ದೋಷ',
  },
  reportIssue: {
    title: 'ಸಮಸ್ಯೆಯನ್ನು ವರದಿ ಮಾಡಿ',
    subtitle: 'ಸಮಸ್ಯೆ ಎದುರಿಸುತ್ತಿದ್ದೀರಾ? ದಯವಿಟ್ಟು ಕೆಳಗಿನ ಫಾರ್ಮ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ, ನಮ್ಮ ಬೆಂಬಲ ತಂಡವು 24-48 ಗಂಟೆಗಳಲ್ಲಿ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.',
    selectIssueType: 'ಸಮಸ್ಯೆ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectUrgency: 'ತುರ್ತುತನವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    beforeSubmit: 'ಸಲ್ಲಿಸುವ ಮೊದಲು:',
    beforeSubmitPoints: [
      'ತಕ್ಷಣದ ಸುರಕ್ಷತಾ ಚಿಂತೆಗಳಿಗೆ, ದಯವಿಟ್ಟು ತುರ್ತು ಸೇವೆಗಳಿಗೆ ಕರೆ ಮಾಡಿ',
      'ನಿಮ್ಮ ರೈಡ್ ರಸೀದಿ ಮತ್ತು ಸಂಬಂಧಿತ ಸ್ಕ್ರೀನ್‌ಶಾಟ್‌ಗಳನ್ನು ಇಟ್ಟುಕೊಳ್ಳಿ',
      'ನಾವು 24-48 ಗಂಟೆಗಳಲ್ಲಿ ಪ್ರತಿಕ್ರಿಯೆ ನೀಡುತ್ತೇವೆ'
    ],
    submitIssue: 'ಸಮಸ್ಯೆ ವರದಿ ಸಲ್ಲಿಸಿ',
    submitting: 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
    success: 'ನಿಮ್ಮ ಸಮಸ್ಯೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ! ನಮ್ಮ ಬೆಂಬಲ ತಂಡವು ಶೀಘ್ರದಲ್ಲೇ ಅದನ್ನು ಪರಿಹರಿಸುತ್ತದೆ.',
    error: 'ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಪ್ರಯತ್ನಿಸಿ.',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  },
  common: {
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    error: 'ದೋಷ',
    success: 'ಯಶಸ್ಸು',
    submit: 'ಸಲ್ಲಿಸಿ',
    cancel: 'ರದ್ದುಮಾಡಿ',
    back: 'ಹಿಂದೆ',
    next: 'ಮುಂದೆ',
    save: 'ಉಳಿಸಿ',
    edit: 'ತಿದ್ದುಪಡಿ',
    delete: 'ಅಳಿಸಿ',
    close: 'ಮುಚ್ಚಿ',
    open: 'ತೆರೆ',
    yes: 'ಹೌದು',
    no: 'ಇಲ್ಲ',
    required: 'ಅಗತ್ಯ',
    optional: 'ಐಚ್ಛಿಕ',
  },
  aboutYou: {
    basicInfo: 'ಮೂಲ ಮಾಹಿತಿ',
    firstName: 'ಮೊದಲ ಹೆಸರು',
    lastName: 'ಕೊನೆಯ ಹೆಸರು',
    gender: 'ಲಿಂಗ',
    male: 'ಪುರುಷ',
    female: 'ಮಹಿಳೆ',
    other: 'ಇತರೆ',
    preferNotToSay: 'ಹೇಳಲು ಇಚ್ಛಿಸುವುದಿಲ್ಲ',
    dateOfBirth: 'ಹುಟ್ಟಿದ ದಿನಾಂಕ',
    contactInfo: 'ಸಂಪರ್ಕ ಮಾಹಿತಿ',
    email: 'ಇಮೇಲ್ ವಿಳಾಸ',
    phoneNumber: 'ಫೋನ್ ಸಂಖ್ಯೆ',
    addressInfo: 'ವಿಳಾಸ ಮಾಹಿತಿ',
    address: 'ವಿಳಾಸ',
    city: 'ನಗರ',
    state: 'ರಾಜ್ಯ',
    pincode: 'ಪಿನ್ ಕೋಡ್',
    emergencyContact: 'ತುರ್ತು ಸಂಪರ್ಕ',
    emergencyContactNumber: 'ಸಂಪರ್ಕ ಸಂಖ್ಯೆ',
    relationship: 'ಸಂಬಂಧ',
    selectRelationship: 'ಸಂಬಂಧವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    spouse: 'ಗಂಡ/ಹೆಂಡತಿ',
    sibling: 'ಸಹೋದರ/ಸಹೋದರಿ',
    friend: 'ಸ್ನೇಹಿತ',
    parent: 'ಪೋಷಕರು',
    
    saveProfile: 'ಪ್ರೊಫೈಲ್ ಮಾಹಿತಿಯನ್ನು ಉಳಿಸಿ',
    phFirstName: 'ಮೊದಲ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    phLastName: 'ಕೊನೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    phEmail: 'ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ',
    phPhone: 'ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
    phAddress: 'ನಿಮ್ಮ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ',
    phCity: 'ನಗರವನ್ನು ನಮೂದಿಸಿ',
    phState: 'ರಾಜ್ಯವನ್ನು ನಮೂದಿಸಿ',
    phPincode: 'ಪಿನ್ ಕೋಡ್ ನಮೂದಿಸಿ',
    phEmergencyContact: 'ತುರ್ತು ಸಂಪರ್ಕ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
    save:'ಸಂಗ್ರಹಿಸಿ',
    edit:'ತಿದ್ದುಪಡಿ',
        // ... existing keys ...
        firstNameRequired: 'ಮೊದಲ ಹೆಸರು ಅಗತ್ಯವಿದೆ.',
        firstNameInvalid: 'ಮೊದಲ ಹೆಸರು ಅಕ್ಷರಗಳು, ಖಾಲಿ ಜಾಗಗಳು, ಅಪೋಸ್ಟ್ರೋಫಿಗಳು ಅಥವಾ ಹೈಫನ್‌ಗಳು ಮಾತ್ರ ಇರಬೇಕು.',
        lastNameRequired: 'ಕೊನೆಯ ಹೆಸರು ಅಗತ್ಯವಿದೆ.',
        lastNameInvalid: 'ಕೊನೆಯ ಹೆಸರು ಅಕ್ಷರಗಳು, ಖಾಲಿ ಜಾಗಗಳು, ಅಪೋಸ್ಟ್ರೋಫಿಗಳು ಅಥವಾ ಹೈಫನ್‌ಗಳು ಮಾತ್ರ ಇರಬೇಕು.',
        emailRequired: 'ಇಮೇಲ್ ಅಗತ್ಯವಿದೆ.',
        emailInvalid: 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.',
        phoneRequired: 'ಫೋನ್ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ.',
        phoneInvalid: 'ಫೋನ್ ಸಂಖ್ಯೆ 10 ರಿಂದ 15 ಅಂಕಿಗಳ ನಡುವೆ ಇರಬೇಕು.',
        dobRequired: 'ಹುಟ್ಟಿದ ದಿನಾಂಕ ಅಗತ್ಯವಿದೆ.',
        dobInvalid: 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಹುಟ್ಟಿದ ದಿನಾಂಕವನ್ನು ನಮೂದಿಸಿ (YYYY-MM-DD).',
        genderRequired: 'ಲಿಂಗ ಅಗತ್ಯವಿದೆ.',
        addressRequired: 'ವಿಳಾಸ ಅಗತ್ಯವಿದೆ.',
        cityRequired: 'ನಗರ ಅಗತ್ಯವಿದೆ.',
        cityInvalid: 'ನಗರ ಅಕ್ಷರಗಳು, ಖಾಲಿ ಜಾಗಗಳು, ಅಪೋಸ್ಟ್ರೋಫಿಗಳು ಅಥವಾ ಹೈಫನ್‌ಗಳು ಮಾತ್ರ ಇರಬೇಕು.',
        stateRequired: 'ರಾಜ್ಯ ಅಗತ್ಯವಿದೆ.',
        stateInvalid: 'ರಾಜ್ಯ ಅಕ್ಷರಗಳು, ಖಾಲಿ ಜಾಗಗಳು, ಅಪೋಸ್ಟ್ರೋಫಿಗಳು ಅಥವಾ ಹೈಫನ್‌ಗಳು ಮಾತ್ರ ಇರಬೇಕು.',
        countryRequired: 'ದೇಶ ಅಗತ್ಯವಿದೆ.',
        countryInvalid: 'ದೇಶ ಅಕ್ಷರಗಳು, ಖಾಲಿ ಜಾಗಗಳು, ಅಪೋಸ್ಟ್ರೋಫಿಗಳು ಅಥವಾ ಹೈಫನ್‌ಗಳು ಮಾತ್ರ ಇರಬೇಕು.',
        pincodeRequired: 'ಪಿನ್‌ಕೋಡ್ ಅಗತ್ಯವಿದೆ.',
        pincodeInvalid: 'ಪಿನ್‌ಕೋಡ್ 4 ರಿಂದ 10 ಅಂಕಿಗಳ ನಡುವೆ ಇರಬೇಕು.',
        emergencyContactRequired: 'ತುರ್ತು ಸಂಪರ್ಕ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ.',
        emergencyContactInvalid: 'ತುರ್ತು ಸಂಪರ್ಕ ಸಂಖ್ಯೆ 10 ರಿಂದ 15 ಅಂಕಿಗಳ ನಡುವೆ ಇರಬೇಕು.',
        relationshipRequired: 'ಸಂಬಂಧ ಅಗತ್ಯವಿದೆ.',
        relationshipInvalid: 'ದಯವಿಟ್ಟು ತುರ್ತು ಸಂಪರ್ಕಕ್ಕಾಗಿ ಮಾನ್ಯವಾದ ಸಂಬಂಧವನ್ನು ಆಯ್ಕೆಮಾಡಿ.',
        emergencyCountryCodeRequired: 'ತುರ್ತು ದೇಶದ ಕೋಡ್ ಅಗತ್ಯವಿದೆ.',
        fixErrorsBeforeSaving: 'ದಯವಿಟ್ಟು ಹೈಲೈಟ್ ಮಾಡಿದ ಕ್ಷೇತ್ರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಪ್ರೊಫೈಲ್ ಉಳಿಸುವ ಮೊದಲು ಎಲ್ಲಾ ದೋಷಗಳನ್ನು ಸರಿಪಡಿಸಿ.',

  },
  account: {
    goodMorning: 'ಶುಭೋದಯ',
    goodAfternoon: 'ಶುಭ ಮಧ್ಯಾಹ್ನ',
    goodEvening: 'ಶುಭ ಸಂಜೆ',
    completeIdentity: 'ನಿಮ್ಮ ಗುರುತನ್ನು ದೃಢೀಕರಿಸಿ',
    addEmergencyContact: 'ತುರ್ತು ಸಂಪರ್ಕ ಮಾಹಿತಿಯನ್ನು ಸೇರಿಸಿ',
    uploadDriverLicense: 'ಚಾಲಕ ಪರವಾನಗಿಯನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
    aboutYou: 'ನಿಮ್ಮ ಬಗ್ಗೆ',
    aboutYouDesc: 'ನಿಮ್ಮ ಬಗ್ಗೆ ಹೇಳಿ',
    identityVerification: 'ಗುರುತು ಪರಿಶೀಲನೆ',
    identityVerificationDesc: 'ನಿಮ್ಮ ಗುರುತನ್ನು ದೃಢೀಕರಿಸಿ',
    offerRides: 'ರೈಡ್‌ಗಳನ್ನು ನೀಡಿರಿ',
    offerRidesDesc: 'ನಿಮ್ಮ ಚಾಲಕ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಹೊಂದಿಸಿ',
    findRides: 'ರೈಡ್‌ಗಳನ್ನು ಹುಡುಕಿ',
    findRidesDesc: 'ನಿಮ್ಮ ಪ್ರಯಾಣ ಆದ್ಯತೆಗಳು',
    appSettings: 'ಆಪ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    appSettingsDesc: 'ನಿಮ್ಮ ಅನುಭವವನ್ನು ವೈಯಕ್ತೀಕರಿಸಿ',
    walletPayments: 'ವಾಲೆಟ್ & ಪಾವತಿಗಳು',
    walletPaymentsDesc: 'ನಿಮ್ಮ ಹಣವನ್ನು ನಿರ್ವಹಿಸಿ',
    supportGrievances: 'ಬೆಂಬಲ & ದೂರುಗಳು',
    supportGrievancesDesc: 'ಸಹಾಯ ಪಡೆಯಿರಿ ಅಥವಾ ದೂರು ಸಲ್ಲಿಸಿ',
    actionRequired: 'ಕ್ರಿಯೆ ಅಗತ್ಯವಿದೆ',
    completeProfile: 'ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ',
    profileHelp: 'ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ ನಿಮಗೆ ಸೂಕ್ತ ರೈಡ್‌ಗಳನ್ನು ನಮ್ಮ AI ಕಂಡುಹಿಡಿಯಲು ಸಹಾಯಮಾಡಿ!',
  },
  settings: {
    appSettings: 'ಆಪ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    appSettingsDesc: 'ನಿಮ್ಮ Duri  ಅನುಭವವನ್ನು ವೈಯಕ್ತೀಕರಿಸಿ ಮತ್ತು ಗೌಪ್ಯತಾ ಆಯ್ಕೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ.',
    languageRegion: 'ಭಾಷೆ & ಪ್ರದೇಶ',
    languagePrompt: 'ನೀವು ಯಾವ ಭಾಷೆಯನ್ನು ಇಚ್ಛಿಸುತ್ತೀರಿ?',
    timezone: 'ಸಮಯ ವಲಯ',
    currency: 'ಕರೆನ್ಸಿ',
    appPermissions: 'ಆಪ್ ಅನುಮತಿಗಳು',
    appPermissionsDesc: 'ಈ ಅನುಮತಿಗಳು ನಿಮಗೆ ಉತ್ತಮ ರೈಡ್ ಅನುಭವವನ್ನು ನೀಡಲು ಸಹಾಯಮಾಡುತ್ತವೆ. ನೀವು ಇವುಗಳನ್ನು ಯಾವಾಗ ಬೇಕಾದರೂ ಬದಲಾಯಿಸಬಹುದು.',
    locationAccess: 'ಸ್ಥಳ ಪ್ರವೇಶ',
    locationAccessDesc: 'ಹತ್ತಿರದ ರೈಡ್‌ಗಳನ್ನು ತೋರಿಸಲು ಮತ್ತು ನಾವಿಗೇಶನ್ ನೀಡಲು ಅನುಮತಿಸಿ',
    readSmsOtp: 'SMS/OTP ಓದಿ',
    readSmsOtpDesc: 'ವೇಗದ ಪರಿಶೀಲನೆಗಾಗಿ OTP ಕೋಡ್‌ಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಭರ್ತಿ ಮಾಡಿ',
    phoneCalls: 'ಫೋನ್ ಕರೆಗಳು',
    phoneCallsDesc: 'ಸಮನ್ವಯಕ್ಕಾಗಿ ರೈಡರ್‌ಗಳು/ಪ್ರಯಾಣಿಕರಿಗೆ ಕರೆ ಮಾಡಲು ಅನುಮತಿಸಿ',
    notifications: 'ಅಧಿಸೂಚನೆಗಳು',
    notificationsDesc: 'ನಿಮ್ಮ ರೈಡ್‌ಗಳು ಮತ್ತು Duri  ಸುದ್ದಿಗಳ ಬಗ್ಗೆ ಹೇಗೆ ಅಪ್‌ಡೇಟ್ ಆಗಬೇಕು ಎಂದು ಆಯ್ಕೆಮಾಡಿ.',
    pushNotifications: 'ಪುಷ್ ಅಧಿಸೂಚನೆಗಳು',
    pushNotificationsDesc: 'ರೈಡ್ ಅಪ್‌ಡೇಟ್‌ಗಳು, ಸಂದೇಶಗಳು ಮತ್ತು ಪ್ರಮುಖ ಅಧಿಸೂಚನೆಗಳು',
    emailNotifications: 'ಇಮೇಲ್ ಅಧಿಸೂಚನೆಗಳು',
    emailNotificationsDesc: 'ಇಮೇಲ್ ಮೂಲಕ ರೈಡ್ ದೃಢೀಕರಣಗಳು ಮತ್ತು ರಸೀದಿಗಳು',
    smsNotifications: 'SMS ಅಧಿಸೂಚನೆಗಳು',
    smsNotificationsDesc: 'ಪ್ರಮುಖ ರೈಡ್ ಅಪ್‌ಡೇಟ್‌ಗಳು ಮೆಸೇಜ್ ಮೂಲಕ',
    rideReminders: 'ರೈಡ್ ರಿಮೈಂಡರ್‌ಗಳು',
    rideRemindersDesc: 'ಬರುವ ರೈಡ್‌ಗಳ ಬಗ್ಗೆ ರಿಮೈಂಡರ್‌ಗಳು',
    promotionalUpdates: 'ಪ್ರಚಾರ ಅಪ್‌ಡೇಟ್‌ಗಳು',
    promotionalUpdatesDesc: 'ವಿಶೇಷ ಆಫರ್‌ಗಳು ಮತ್ತು ಹೊಸ ವೈಶಿಷ್ಟ್ಯಗಳು',
    saveSettings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಉಳಿಸಿ',
  },
  header: {
    home: 'ಮುಖಪುಟ',
    findRide: 'ರೈಡ್ ಹುಡುಕಿ',
    offerRide: 'ರೈಡ್ ನೀಡಿರಿ',
    manageRides: 'ರೈಡ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
    account: 'ಖಾತೆ',
    logout: 'ಲಾಗ್ ಔಟ್',
    aiAssistant: 'Duri  AI ಸಹಾಯಕ',
    findPerfectRideMatch: 'ನಿಮಗೆ ಸೂಕ್ತವಾದ ರೈಡ್ ಅನ್ನು ಹುಡುಕಿ',
    connectWithTravelers: 'ನಿಮ್ಮ ಮಾರ್ಗದಲ್ಲಿನ ಪ್ರಯಾಣಿಕರೊಂದಿಗೆ ಸಂಪರ್ಕ ಸಾಧಿಸಿ',
    askAiFindingRides: 'ರೈಡ್‌ಗಳನ್ನು ಹುಡುಕಲು AI ಅನ್ನು ಕೇಳಿ...',
    askAiOfferingRides: 'ರೈಡ್ ನೀಡಲು AI ಅನ್ನು ಕೇಳಿ...',
    findRidesToBandra: 'ಬಾಂದ್ರಾಗೆ ರೈಡ್‌ಗಳನ್ನು ಹುಡುಕಿ',
    cheapestRouteToAirport: 'ವಿಮಾನ ನಿಲ್ದಾಣಕ್ಕೆ ಅಗ್ಗದ ಮಾರ್ಗ',
    dailyCommuteToPowai: 'ಪೊವೈಗೆ ದೈನಂದಿನ ಪ್ರಯಾಣ',
    postRideToGurgaon: 'ಗುರ್ಗಾಂವಿಗೆ ರೈಡ್ ಪೋಸ್ಟ್ ಮಾಡಿ',
    setRecurringRoute: 'ಪುನರಾವೃತ ಮಾರ್ಗವನ್ನು ಹೊಂದಿಸಿ',
    managePassengers: 'ಪ್ರಯಾಣಿಕರನ್ನು ನಿರ್ವಹಿಸಿ',
    benefits: 'ಲಾಭಗಳು',
    howItWorks: 'ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ',
    findARide: 'ರೈಡ್ ಹುಡುಕಿ',
    safety: 'ಭದ್ರತೆ',
    support: 'ಸಹಾಯ',
    login: 'ಲಾಗಿನ್',
    getStarted: 'ಪ್ರಾರಂಭಿಸಿ',
  },
  footer: {
    downloadAppTitle: 'Duri ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
    downloadAppDesc: 'ಉತ್ತಮ ಅನುಭವಕ್ಕಾಗಿ ಮೊಬೈಲ್ ಆಪ್ ಪಡೆಯಿರಿ, ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್, ತಕ್ಷಣದ ಅಧಿಸೂಚನೆಗಳು ಮತ್ತು ಸುಲಭ ರೈಡ್ ಬುಕ್ಕಿಂಗ್. ಎಲ್ಲಾ ಸಾಧನಗಳಲ್ಲಿ ಉಚಿತವಾಗಿ ಲಭ್ಯವಿದೆ.',
    getItOn: 'ಇದರಲ್ಲಿ ಪಡೆಯಿರಿ',
    googlePlay: 'ಗೂಗಲ್ ಪ್ಲೇ',
    downloadOnThe: 'ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
    appStore: 'ಆಪ್ ಸ್ಟೋರ್',
    scanForAndroid: 'Android ಗೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
    scanForIOS: 'iOS ಗೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
    googlePlayStore: 'ಗೂಗಲ್ ಪ್ಲೇ ಸ್ಟೋರ್',
    appleAppStore: 'ಆಪಲ್ ಆಪ್ ಸ್ಟೋರ್',
    brandDesc: 'ಸ್ಮಾರ್ಟ್, ಸುರಕ್ಷಿತ ಮತ್ತು ಸ್ಥಿರ ರೈಡ್ ಶೇರ್ ಮೂಲಕ ಜಗತ್ತಿನಾದ್ಯಾಂತ ಪ್ರಯಾಣಿಕರನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ. ಪ್ರಯಾಣವನ್ನು ಉತ್ತಮಗೊಳಿಸಿದ ಲಕ್ಷಾಂತರ ಜನರಲ್ಲಿ ಸೇರಿ, ಹಣ ಉಳಿಸಿ ಮತ್ತು ನಮ್ಮ ಗ್ರಹವನ್ನು ರಕ್ಷಿಸಿ.',
    contactEmail: 'contact@hansaitechnosoft.com',
    contactPhone: '+91 76809 38741',
    contactHours: 'Available hrs: 8 AM to 10 PM IST',
    availableCountries: '25+ ದೇಶಗಳಲ್ಲಿ ಲಭ್ಯವಿದೆ',
    sectionCompany: 'ಕಂಪನಿ',
    sectionGuests: 'ಅತಿಥಿಗಾಗಿ',
    sectionHosts: 'ಹೋಸ್ಟ್‌ಗಳಿಗಾಗಿ',
    sectionTravelers: 'ಪ್ರಯಾಣಿಕರಿಗಾಗಿ',
    sectionSupport: 'ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ',
    sectionLegal: 'ಕಾನೂನು ಮತ್ತು ಅನುಪಾಲನೆ',
    sectionCountries: 'ಲಭ್ಯವಿರುವ ದೇಶಗಳು',
    companyLinks: {
      aboutUs: 'ನಮ್ಮ ಬಗ್ಗೆ',
      news: 'ಸುದ್ದಿ ಮತ್ತು ಅಪ್‌ಡೇಟ್‌ಗಳು',
      howItWorks: 'ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ',
      safety: 'ಸುರಕ್ಷತೆ',
      careers: 'ಕೆರಿಯರ್‌ಗಳು',
      press: 'ಪ್ರೆಸ್',
      duriGreenMobility: 'ಡ್ಯೂರಿ ಗ್ರೀನ್ ಮೊಬಿಲಿಟಿ',
    },
    guestLinks: {
      howToBook: 'ರೈಡ್ ಹೇಗೆ ಬುಕ್ ಮಾಡುವುದು?',
      findARide: 'ರೈಡ್ ಹುಡುಕಿ',
      availableRides: 'ಲಭ್ಯವಿರುವ ರೈಡ್‌ಗಳು',
      searchByRideId: 'ರೈಡ್ Id ನಿಂದ ಹುಡುಕಿ',
      searchByRider: 'ರೈಡರ್ ನಿಂದ ಹುಡುಕಿ',
      howToBookGuide: 'ರೈಡ್ ಹೇಗೆ ಬುಕ್ ಮಾಡುವುದು',
      howToDailyCommute: 'ಡೈಲಿ ಕಮ್ಯೂಟ್ ಹೇಗೆ',
      commuteCalculator: 'ಕಮ್ಯೂಟ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್ (ಅತಿಥಿ)',
    },
    hostLinks: {
      howToHost: 'ರೈಡ್ ಹೇಗೆ ಹೋಸ್ಟ್ ಮಾಡುವುದು?',
      rideRequests: 'ರೈಡ್ ವಿನಂತಿಗಳು',
      lookUpARide: 'ರೈಡ್ ನೋಡಿ',
      howToDailyCommute: 'ಡೈಲಿ ಕಮ್ಯೂಟ್ ಹೇಗೆ',
      popularRoutes: 'ಜನಪ್ರಿಯ ರೈಡ್‌ಗಳು',
      commuteCalculator: 'ಕಮ್ಯೂಟ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್ (ಹೋಸ್ಟ್)',
    },
    travelersLinks: {
      findRides: 'ರೈಡ್‌ಗಳನ್ನು ಹುಡುಕಿ',
      offerRides: 'ರೈಡ್‌ಗಳನ್ನು ನೀಡಿರಿ',
      mobileApp: 'ಮೊಬೈಲ್ ಆಪ್',
      referFriends: 'ಸ್ನೇಹಿತರನ್ನು ಶಿಫಾರಸು ಮಾಡಿ',
      helpCenter: 'ಸಹಾಯ ಕೇಂದ್ರ'
    },
    supportLinks: {
      customerSupport: 'ಗ್ರಾಹಕ ಬೆಂಬಲ',
      safetyGuidelines: 'ಸುರಕ್ಷತಾ ಮಾರ್ಗದರ್ಶಿಗಳು',
      trustSafety: 'ನಂಬಿಕೆ & ಸುರಕ್ಷತೆ',
      insurance: 'ವಿಮೆ',
      contactUs: 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
      getHelp: 'ಸಹಾಯ ಪಡೆಯಿರಿ',
      reportIssue: 'ಸಮಸ್ಯೆಯನ್ನು ವರದಿ ಮಾಡಿ',
      myIssues: 'ನನ್ನ ಸಪೋರ್ಟ್ ಟಿಕೆಟ್‌ಗಳು',
      whatsappSupport: 'WhatsApp ಬೆಂಬಲ',
      corporateCarpool: 'ಕಾರ್ಪೊರೇಟ್ ಕಾರ್‌ಪೂಲ್',
    },
    legalLinks: {
      termsOfService: 'ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು',
      privacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
      cookiePolicy: 'ಕುಕಿ ನೀತಿ',
      refundPolicy: 'ರದ್ದುಪಡಿಸುವ ನೀತಿ',
      deleteAccount: 'ಖಾತೆ ಅಳಿಸಿ',
      tripInsurance: 'ಟ್ರಿಪ್ ವಿಮೆ',
      paymentTerms: 'ಪಾವತಿ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು',
      communityGuidelines: 'ಸಮುದಾಯ ಮಾರ್ಗದರ್ಶಿಗಳು'
    },
    copyright: '© 2025 Duri. ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.',
    copyrightText: '@{year} HansAI Techno Soft Private Limited, ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ'
  },
  quickRideFinder: {
    currentLocationDetected: '📍 ಪ್ರಸ್ತುತ ಸ್ಥಳ ಪತ್ತೆಹಚ್ಚಲಾಗಿದೆ',
    greeting1: '👋 ನಮಸ್ಕಾರ! ನೀವು {location} ನಲ್ಲಿ ಇದ್ದೀರಿ ಎಂದು ಕಾಣುತ್ತದೆ.',
    greeting2: 'ಇಂದು ನೀವು ಎಲ್ಲಿಗೆ ಹೋಗಲು ಇಚ್ಛಿಸುತ್ತೀರಿ?',
    letsFindRide: 'ನಾವು ರೈಡ್ ಹುಡುಕೋಣ! ✨',
    destinationPrompt: '🎯 ಚೆನ್ನಾಗಿದೆ! ನಾವು ಎಲ್ಲಿಗೆ ಹೋಗಬೇಕು?',
    destinationSubPrompt: 'ನಿಮ್ಮ ಗಮ್ಯಸ್ಥಾನವನ್ನು ಟೈಪ್ ಮಾಡಿ ಅಥವಾ ಕೆಳಗಿನ ಜನಪ್ರಿಯ ಆಯ್ಕೆಗಳಿಂದ ಆಯ್ಕೆಮಾಡಿ',
    destinationPlaceholder: 'ಉದಾ., ಪುಣೆ, ದೆಹಲಿ, ಬೆಂಗಳೂರು...',
    nextWhen: 'ಮುಂದೆ: ಯಾವಾಗ? →',
    datePrompt: '📅 ಉತ್ತಮ ಆಯ್ಕೆ! {from} ರಿಂದ {to}',
    dateSubPrompt: 'ನೀವು ಯಾವಾಗ ಪ್ರಯಾಣಿಸಲು ಇಚ್ಛಿಸುತ್ತೀರಿ?',
    nextPassengers: 'ಮುಂದೆ: ಎಷ್ಟು ಪ್ರಯಾಣಿಕರು? →',
    passengersPrompt: '👥 ಇನ್ನೂ ಸ್ವಲ್ಪ! ಎಷ್ಟು ಪ್ರಯಾಣಿಕರು?',
    passengersSubPrompt: 'ನೀವು ಸೇರಿ',
    perfectFindRides: 'ಚೆನ್ನಾಗಿದೆ! ರೈಡ್ಗಳನ್ನು ಹುಡುಕೋಣ →',
    readyTitle: '🎉 ಹುಡುಕಲು ಸಿದ್ಧ!',
    from: 'ಇಂದ:',
    to: 'ಗೆ:',
    date: 'ದಿನಾಂಕ:',
    passengers: 'ಪ್ರಯಾಣಿಕರು:',
    person: 'ವ್ಯಕ್ತಿ',
    people: 'ಜನರು',
    findMyPerfectRide: 'ನನ್ನ ಪರಿಪೂರ್ಣ ರೈಡ್ ಹುಡುಕಿ!',
    popularRoutes: '{city} ನಿಂದ ಜನಪ್ರಿಯ ಮಾರ್ಗಗಳು',
    today: 'ಇಂದು',
    tomorrow: 'ನಾಳೆ',
    thisWeekend: 'ಈ ವಾರಾಂತ್ಯ',
    locationNotFoundLabel: '📍 ಸ್ಥಳ ಕಂಡುಬಂದಿಲ್ಲ',
    locationNotFoundMessage: 'ದಯವಿಟ್ಟು ಸ್ಥಳ ಪ್ರವೇಶವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ ಅಥವಾ ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಸ್ಥಳವನ್ನು ಕೈಯಾರೆ ನಮೂದಿಸಿ!',
  },
  hero: {
    badge: 'ನಮ್ಮ ಪರಿಶೀಲಿತ ರೈಡ್‌ಶೇರಿಂಗ್ ವೇದಿಕೆಯಲ್ಲಿ 10 ಮಿಲಿಯನ್‌ಗಿಂತ ಹೆಚ್ಚು ಅತಿಥಿಗಳ ವಿಶ್ವಾಸ',
    mainTitle: 'ರೈಡ್ ಹಂಚಿಕೊಳ್ಳಿ, ಉಳಿಸಿ',
    mainTitleHighlight: 'ಪರ್ಸ್ ಮತ್ತು ಗ್ರಹ',
    subtitle: 'ಅತ್ಯಂತ ವಿಶ್ವಾಸಾರ್ಹ ಅಂತರನಗರ ರೈಡ್‌ಶೇರಿಂಗ್ ಆಪ್‌ಗೆ ಸೇರಿ — ನಿಮ್ಮ ಪ್ರಯಾಣವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ, ಹೆಚ್ಚು ಉಳಿಸಿ, ಮತ್ತು ಚಾತುರ್ಯದಿಂದ ಪ್ರಯಾಣಿಸಿ.',
    findRide: 'ರೈಡ್ ಹುಡುಕಿ',
    offerRide: 'ರೈಡ್ ನೀಡಿರಿ',
    statSaved: 'ಒಟ್ಟು ಉಳಿಸಿದ',
    statCO2: 'CO₂ ಟನ್ ಕಡಿತ',
    statHappy: 'ಸಂತೋಷಕರ ಪ್ರಯಾಣಗಳು',
  },
  benefits: {
    badge: 'ಏಕೆ Duri?',
    sectionTitle: 'ನಿಮಗೆ ಬೇಕಾದ ಎಲ್ಲವೂ',
    sectionSubtitle: 'ಸ್ಮಾರ್ಟ್, ಸುರಕ್ಷಿತ ಮತ್ತು ಸ್ಥಿರ ಪ್ರಯಾಣಕ್ಕಾಗಿ.',
    saveMoneyTitle: 'ಹಣ ಉಳಿಸಿ',
    saveMoneyDesc: 'ಕಡಿಮೆ ವೆಚ್ಚದ ರೈಡ್‌ಶೇರಿಂಗ್ ಆಯ್ಕೆಗಳೊಂದಿಗೆ ಬಜೆಟ್ ಪ್ರಯಾಣವನ್ನು ಆನಂದಿಸಿ, ಇದು ಖರ್ಚುಗಳನ್ನು 70% ರಷ್ಟು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ',
    saveMoneyStats: 'ಸರಾಸರಿ ವಾರ್ಷಿಕ ₹15,000 ಉಳಿಕೆ',
    helpPlanetTitle: 'ಪೃಥ್ವಿಗೆ ಸಹಾಯ ಮಾಡಿ',
    helpPlanetDesc: 'ಪ್ರತಿಯೊಂದು ಹಂಚಿಕೆಯ ಟ್ರಾವೆಲ್ ಆಪ್ ಪ್ರಯಾಣದೊಂದಿಗೆ CO₂ ಅನ್ನು ಕಡಿಮೆ ಮಾಡಿ ಮತ್ತು ಹಸಿರು ಪ್ರಯಾಣ ಪರಿಹಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    helpPlanetStats: 'ಪ್ರತಿ 100ಕಿಮೀಗೆ 2.3 ಕೆಜಿ CO₂ ಉಳಿಕೆ',
    travelSafeTitle: 'ಸುರಕ್ಷಿತವಾಗಿ ಪ್ರಯಾಣಿಸಿ',
    travelSafeDesc: 'ಪರಿಶೀಲಿತ ಹೋಸ್ಟ್‌ಗಳು ಮತ್ತು ರಿಯಲ್‌ಟೈಮ್ ರೈಡ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಹೊಂದಿರುವ ವಿಶ್ವಾಸಾರ್ಹ ಕಾರ್‌ಪೂಲ್ ಆಪ್‌',
    travelSafeStats: '99.8% ಅಪಘಾತ ರಹಿತ ರೈಡ್ಸ್',
    anyTimeTitle: 'ಯಾವಾಗ ಬೇಕಾದರೂ',
    anyTimeDesc: 'ನಮ್ಮ ರಿಯಲ್‌ಟೈಮ್ ನಾವಿಗೇಶನ್ ಆಪ್‌ನೊಂದಿಗೆ ಯಾವಾಗ ಬೇಕಾದರೂ ಸಿಟಿ-ಟು-ಸಿಟಿ ರೈಡ್‌ಗಳನ್ನು ಪ್ರವೇಶಿಸಿ',
    anyTimeStats: 'ಯಾವಾಗಲೂ ಲಭ್ಯವಿದೆ',
    meetPeopleTitle: 'ಜನರನ್ನು ಭೇಟಿಯಾಗಿರಿ',
    meetPeopleDesc: 'ನಮ್ಮ ಬೆಳೆುತ್ತಿರುವ ರೈಡ್ ಶೇರಿಂಗ್ ಸಮುದಾಯದ ಮೂಲಕ ಸಂಪರ್ಕ ಸಾಧಿಸಿ ಜೊತೆಯಾಗಿ ಪ್ರಯಾಣಿಸಿ',
    meetPeopleStats: '85% ಬಳಕೆದಾರರು ಸಂಪರ್ಕ ಹೊಂದಿದ್ದಾರೆ',
    goAnywhereTitle: 'ಎಲ್ಲಿಗೆ ಬೇಕಾದರೂ ಹೋಗಿ',
    goAnywhereDesc: 'ಬಹು ದೇಶಗಳಲ್ಲಿ 500+ ಸ್ಥಳಗಳಿಗೆ ಪ್ರವೇಶ',
    goAnywhereStats: 'ವಿಶ್ವದಾದ್ಯಾಂತ 500+ ನಗರಗಳು',
  },
  statistics:{
    sectionTitle: "ನಮ್ಮ ಅಂಕಿಅಂಶಗಳು",
  sectionSubtitle: "ವಿಶ್ವದಾದ್ಯಾಂತ ಪ್ರಯಾಣಿಕರಿಗೆ ನಾವು ನೀಡುತ್ತಿರುವ ಪರಿಣಾಮವನ್ನು ನೋಡಿ.",
  travelersLabel: "ಪ್ರಯಾಣಿಕರು",
  travelersDesc: "ನಮ್ಮನ್ನು ನಂಬಿರುವವರು",
  citiesLabel: "ನಗರಗಳು",
  citiesDesc: "ನಾವು ಸೇವೆ ನೀಡುತ್ತಿರುವವು",
  savedLabel: "ಒಟ್ಟು ಉಳಿಕೆ",
  savedDesc: "ಪ್ರಯಾಣ ವೆಚ್ಚದಲ್ಲಿ",
  co2Label: "CO₂ ಕಡಿತ",
  co2Desc: "ಉತ್ಸರ್ಜನೆ ಉಳಿಸಲಾಗಿದೆ — ಪರಮ ಕಾರ್ಬನ್ ಉಳಿಸುವ ಪ್ರಯಾಣ ಪರಿಹಾರ",
  costReductionLabel: "ವೆಚ್ಚ ಕಡಿತ",
  costReductionSuffix: "% ಕಡಿಮೆ ವೆಚ್ಚ",
  emissionReductionLabel: "ಉತ್ಪತ್ತಿ ಕಡಿತ",
  emissionReductionSuffix: "% ಕಡಿಮೆ CO₂",
  userSatisfactionLabel: "ಬಳಕೆದಾರರ ತೃಪ್ತಿ",
  userSatisfactionSuffix: "% ಸಂತೋಷವಾಗಿರುವವರು",
  safetyRateLabel: "ಭದ್ರತಾ ಪ್ರಮಾಣ",
  safetyRateSuffix: "% ಭದ್ರತಾ ಪ್ರಮಾಣ"
  },
  safety:{
  badge: "ಭದ್ರತೆ",
  sectionTitle: "ನಿಮ್ಮ",
  sectionTitleHighlight: "ಭದ್ರತೆ ನಮ್ಮ ಆದ್ಯತೆ",
  sectionSubtitle: "ಸುರಕ್ಷಿತ ಪ್ರಯಾಣ, ವಿಶ್ವಾಸಾರ್ಹ ಮತ್ತು ಹೊಂದಾಣಿಕೆಯ ರೈಡ್ ಅನುಭವಗಳನ್ನು ಖಚಿತಪಡಿಸಲು ನಮ್ಮ ವಿಶ್ವಾಸಾರ್ಹ ರೈಡ್ ಶೇರಿಂಗ್ ಆಪ್‌ನಲ್ಲಿ ಪ್ರತಿಯೊಬ್ಬ ಬಳಕೆದಾರರನ್ನು ಪರಿಶೀಲಿಸಲಾಗಿದೆ.",
  backgroundVerified: "ಹಿನ್ನೆಲೆ ಪರಿಶೀಲನೆ",
  safeRidesCompleted: "ಸುರಕ್ಷಿತ ಪ್ರಯಾಣಗಳು",
  trustScoreAverage: "ನಂಬಿಕೆ ಸ್ಕೋರ್ ಸರಾಸರಿ",
  emergencyResponse: "ತುರ್ತು ಪ್ರತಿಕ್ರಿಯೆ",
  idVerificationTitle: "ಗುರುತು ಪರಿಶೀಲನೆ",
  idVerificationDesc: "ಪ್ರತಿ ಪ್ರಯಾಣಿಕ ಮತ್ತು ಚಾಲಕರ ಗುರುತು ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.",
  idVerificationStats: "100% KYC ಪೂರ್ಣಗೊಂಡಿದೆ",
  professionalTitle: "ವೃತ್ತಿಪರ ಚಾಲಕರು",
  professionalDesc: "ಅನುಭವ ಮತ್ತು ತರಬೇತಿ ಪಡೆದ ಚಾಲಕರು ಮಾತ್ರ.",
  professionalStats: "90% ಚಾಲಕರು ವೃತ್ತಿಪರರು",
  cultureTitle: "ಸಾಂಸ್ಕೃತಿಕ ವೈವಿಧ್ಯತೆ",
  cultureDesc: "ವಿವಿಧ ಹಿನ್ನೆಲೆಯಿಂದ ಪ್ರಯಾಣಿಕರು ಮತ್ತು ಚಾಲಕರು.",
  cultureStats: "30+ ಭಾಷೆ ಮಾತನಾಡುವವರು",
  interestsTitle: "ಸಾಮಾನ್ಯ ಆಸಕ್ತಿಗಳು",
  interestsDesc: "ನಿಮ್ಮ ಆಸಕ್ತಿಗಳಿಗೆ ಹೊಂದಿಕೊಳ್ಳುವ ಪ್ರಯಾಣದ ಸಂಗಾತಿಗಳು.",
  interestsStats: "80% ಹೊಂದಾಣಿಕೆ ದರ",
  trackingTitle: "ನೇರ ಟ್ರ್ಯಾಕಿಂಗ್",
  trackingDesc: "ಪ್ರತಿಯೊಂದು ಪ್ರಯಾಣದಿಗಾಗಿ ರಿಯಲ್‌ಟೈಮ್ ರೈಡ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಸ್ಮಾರ್ಟ್ ಮೊಬಿಲಿಟಿ ಸೊಲ್ಯೂಷನ್ಸ್ ಮೂಲಕ ಸುರಕ್ಷಿತವಾಗಿರಿ.",
  trackingStats: "24/7 ಟ್ರ್ಯಾಕಿಂಗ್",
  secureCommTitle: "ಭದ್ರ ಸಂವಹನ",
  secureCommDesc: "ಪರಿಶೀಲಿತ ಹೋಸ್ಟ್‌ಗಳು ಮತ್ತು ಅತಿಥಿಗಳಿಗಾಗಿ ನಮ್ಮ ಆಪ್‌ನಲ್ಲಿ ಸುರಕ್ಷಿತ ಸಂವಹನವನ್ನು ಅನುಭವಿಸಿ — ಗೌಪ್ಯತೆ ಗ್ಯಾರಂಟಿ.",
  secureCommStats: "ಎಂಡ್-ಟು-ಎಂಡ್ ಎನ್‌ಕ್ರಿಪ್ಷನ್",
  ctaTitle: "ನಮ್ಮ ಭದ್ರತಾ ಮಾನದಂಡಗಳನ್ನು ಅನುಭವಿಸಿ",
  ctaDesc: "ನೀವು ಪ್ರಯಾಣಿಸುವಾಗ ನಿಮ್ಮ ಭದ್ರತೆಯನ್ನು ನಾವು ಖಚಿತಪಡಿಸುತ್ತೇವೆ.",
  ctaButton: "ಈಗ ಸೇರಿ"
  }, 
  howItWorks: {
    sectionTitle: "ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ?",
  sectionSubtitle: "ನಿಮ್ಮ ಪ್ರಯಾಣದ ಅನುಭವವನ್ನು ರೂಪಾಂತರಿಸುವ ನಾಲ್ಕು ಸರಳ ಹಂತಗಳು — ಹೋಸ್ಟ್ ಆಗಿ.",
  searchTitle: "ನಿಮ್ಮ ರೈಡ್ ಸೇರಿಸಿ",
  searchDesc: "ಕೆಲವು ಕ್ಲಿಕ್‌ಗಳಲ್ಲಿ ನಿಮ್ಮ ಖಾಲಿ ಆಸನಗಳು ಮತ್ತು ಮಾರ್ಗಗಳನ್ನು ಗೇಸ್ಟ್ಗೆ ನೀಡಿರಿ.",
  connectTitle: "ಸಂಪರ್ಕಿಸಿ",
  connectDesc: "ಬುಕ್ಕಿಂಗ್‌ಗಳನ್ನು ದೃಢೀಕರಿಸಲು ಮತ್ತು ಪ್ರಯಾಣ ಸುಗಮವಾಗಿಸಲು ಗೇಸ್ಟ್ರೊಂದಿಗೆ ಸಂವಹನ ಮಾಡಿ.",
  payTitle: "ಸಂಪಾದಿಸಿ",
  payDesc: "ಪ್ರತಿ ಹಂಚಿದ ರೈಡ್‌ಗಾಗಿ ಸುರಕ್ಷಿತವಾಗಿ ಸಂಬಳ ಪಡೆಯಿರಿ ಮತ್ತು ನಿಮ್ಮ ವಾಹನದ ಬಳಸಿಕೆಯನ್ನು ಗರಿಷ್ಠಗೊಳಿಸಿ.",
  travelTitle: "ಡ್ರೈವ್ ಮಾಡಿ",
  travelDesc: "ರಿಯಲ್-ಟೈಮ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಗೇಸ್ಟ್ ರೇಟಿಂಗ್ಸ್ જેવી ವೈಶಿಷ್ಟ್ಯಗಳೊಂದಿಗೆ ಸುರಕ್ಷಿತ ಮತ್ತು ನಂಬಲರ್ಹ ರೈಡ್‌ಗಳನ್ನು ಒದಗಿಸಿ.",
  GuestsectionSubtitle: 'ನಿಮ್ಮ ಪ್ರಯಾಣದ ಅನುಭವವನ್ನು ರೂಪಾಂತರಿಸುವ ನಾಲ್ಕು ಸರಳ ಹಂತಗಳು — ಗೇಸ್ಟ್ ಆಗಿ.',
  GuestsearchTitle:'ಹುಡುಕಿ',
  GuestsearchDesc:'ನಿಮ್ಮ ಮಾರ್ಗ ಮತ್ತು ವೇಳಾಪಟ್ಟಿಗೆ ಹೊಂದುವ ದೃಢೀಕೃತ ಹೋಸ್ಟ್‌ಗಳ ರೈಡ್‌ಗಳನ್ನು ಸುಲಭವಾಗಿ ಹುಡುಕಿ.',
  GuestconnectTitle:'ಸಂಪರ್ಕಿಸಿ',
  GuestconnectDesc:'ಪಿಕ್-ಅಪ್ ಪಾಯಿಂಟ್‌ಗಳು ಮತ್ತು ಪ್ರಯಾಣ ವಿವರಗಳನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಸಂಯೋಜಿಸಲು ಹೋಸ್ಟ್ ಜೊತೆ ನೇರವಾಗಿ ಚಾಟ್ ಮಾಡಿ.',
  GuestpayTitle:'ಪಾವತಿಸಿ',
  GuestpayDesc:'ನಿಮ್ಮ ರೈಡ್ ಅನ್ನು ಬುಕ್ ಮಾಡಿ, ವೆಚ್ಚವನ್ನು ಸುಲಭವಾಗಿ ಹಂಚಿ ಮತ್ತು ಸುರಕ್ಷಿತವಾಗಿ ಪಾವತಿಸಿ.',
  GuesttravelTitle:'ಪ್ರಯಾಣಿಸಿ',
  GuesttraveDesc:'ರಿಯಲ್-ಟೈಮ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ರೈಡ್ ಬೆಂಬಲದೊಂದಿಗೆ ಆರಾಮದಾಯಕ ಮತ್ತು ಸುರಕ್ಷಿತ ಪ್ರಯಾಣವನ್ನು ಆನಂದಿಸಿ.'
  },
  testimonials: {
    sectionTitle: 'ನಮ್ಮ ಸಮುದಾಯದ ಕಥೆಗಳು',
    sectionSubtitle: "ಹಂಚಿಕೊಂಡ ಪ್ರಯಾಣದ ಸಂತೋಷವನ್ನು ಕಂಡುಹಿಡಿದ ನಿಜವಾದ ಪ್ರಯಾಣಿಕರಿಂದ ನಿಜವಾದ ಅನುಭವಗಳು.",
    averageRating: 'ಸರಾಸರಿ ರೇಟಿಂಗ್',
    recommendUs: 'ನಮ್ಮನ್ನು ಶಿಫಾರಸು ಮಾಡುತ್ತಾರೆ',
    happyTravelers: 'ಸಂತೋಷದ ಪ್ರಯಾಣಿಕರು',
    customerSupport: 'ಗ್ರಾಹಕ ಬೆಂಬಲ',
    trustedBy: 'ಈ ಉದ್ಯೋಗಿಗಳಿಂದ ನಂಬಿಕೆ',
    items: [
      JSON.stringify({
        name: 'ಪ್ರಿಯಾ ಶರ್ಮಾ',
        role: 'ಸಾಫ್ಟ್‌ವೇರ್ ಎಂಜಿನಿಯರ್',
        location: 'ಮುಂಬೈ → ಪುಣೆ ಮಾರ್ಗ',
        rating: 5,
        text: "ನಾನು ಕಳೆದ 6 ತಿಂಗಳಲ್ಲಿ ನನ್ನ ವಾರಾಂತರ ಮುಂಬೈ-ಪೂಣೆ ಪ್ರಯಾಣಗಳಿಗೆ ರೈಡ್ ಶೇರಿಂಗ್ ಬಳಸಿಕೊಂಡು ₹8,000ಕ್ಕೂ ಹೆಚ್ಚು ಉಳಿತಾಯ ಮಾಡಿದ್ದೇನೆ. ಈ ಆಪ್ ಪರಿಶೀಲಿತ ಹೋಸ್ಟ್‌ಗಳು ಮತ್ತು ಸರಳ ಬುಕಿಂಗ್‌ ಜೊತೆಗೆ ಅತ್ಯಂತ ವಿಶ್ವಾಸಾರ್ಹ ಕಾರ್‌ಪೂಲ್ ಆಪ್ ಆಗಿದೆ.",
        avatar: '👩‍💼',
        savings: '₹8,000 ಉಳಿಕೆ'
      }),
      JSON.stringify({
        name: 'ರಾಜ್ ಪಟೇಲ್',
        role: 'ವ್ಯಾಪಾರ ಮಾಲೀಕ',
        location: 'ದೆಹಲಿ → ಜೈಪುರ ಮಾರ್ಗ',
        rating: 5,
        text: "ನಾನು ತಿಂಗಳಿಗೆ ಎರಡು ಬಾರಿ ಜೈಪುರಕ್ಕೆ ಹೋಗುತ್ತೇನೆ. ಈ ವೇದಿಕೆ ನನ್ನ ಜೀವನವನ್ನು ಸುಲಭಗೊಳಿಸಿದೆ. ಉತ್ತಮ ಸ್ನೇಹಿತರು, ನಂಬಿಗಸ್ತ ಸೇವೆ, ಪರಿಸರಕ್ಕೂ ಸಹಾಯ ಮಾಡುತ್ತಿದ್ದೇನೆ!",
        avatar: '👨‍💼',
        savings: '60% ವೆಚ್ಚ ಕಡಿತ'
      }),
      JSON.stringify({
        name: 'ಅನಿತಾ ರೆಡ್ಡಿ',
        role: 'ಕಾಲೇಜು ವಿದ್ಯಾರ್ಥಿನಿ',
        location: 'ಬೆಂಗಳೂರು → ಚೆನ್ನೈ ಮಾರ್ಗ',
        rating: 5,
        text: "ದಿನನಿತ್ಯದ ಪ್ರಯಾಣ ವೆಚ್ಚವನ್ನು ಉಳಿಸಲು ಕಡಿಮೆ ವೆಚ್ಚದ ಟ್ರಾವೆಲ್ ಆಪ್ ಹುಡುಕುತ್ತಿರುವ ವಿದ್ಯಾರ್ಥಿಗಳು ಮತ್ತು ವೃತ್ತಿಪರರಿಗೆ ಇದು ಪರಿಪೂರ್ಣವಾಗಿದೆ. ಈಗ ನಾನು ಹೆಚ್ಚು ಬಾರಿ ಮನೆಗೆ ಹೋಗಬಹುದು. ಭದ್ರತಾ ವೈಶಿಷ್ಟ್ಯಗಳು ನನ್ನ ಪೋಷಕರಿಗೆ ನೆಮ್ಮದಿ ನೀಡುತ್ತವೆ, ಪ್ರಯಾಣದಲ್ಲಿ ಉತ್ತಮ ಸ್ನೇಹಿತರು ಸಿಕ್ಕಿದ್ದಾರೆ.",
        avatar: '👩‍🎓',
        savings: 'ವಾರ್ಷಿಕ ₹12,000 ಉಳಿಕೆ'
      }),
      JSON.stringify({
        name: 'ವಿಕ್ರಮ್ ಸಿಂಗ್',
        role: 'ಮಾರ್ಕೆಟಿಂಗ್ ಮ್ಯಾನೇಜರ್',
        location: 'ಹೈದರಾಬಾದ್ → ವಿಜಯವಾಡ ಮಾರ್ಗ',
        rating: 5,
        text: "ಸಹ ಪ್ರಯಾಣಿಕರ ಗುಣಮಟ್ಟ ಅತ್ಯುತ್ತಮ. ಅರ್ಥಪೂರ್ಣ ಸಂಭಾಷಣೆಗಳು, ವ್ಯವಹಾರ ಜಾಲತಾಣದ ಅವಕಾಶಗಳು ಸಿಕ್ಕಿವೆ. ಇದು ಕೇವಲ ಹಣ ಉಳಿಸುವ ಬಗ್ಗೆ ಮಾತ್ರವಲ್ಲ.",
        avatar: '👨‍💻',
        savings: 'ಹೊಸ ಸಂಪರ್ಕಗಳು'
      })
    ]
  },
  topBar:{
      welcomeMessage: "ಡ್ಯೂರಿ ರೈಡ್ಶೇಯರಿಂಗ್ಗೆ ಸ್ವಾಗತ — ಪರಿಶೀಲಿಸಿದ ಗಸ್ಟ್ ಮತ್ತು ಹೋಸ್ಟ್‌ಗಳೊಂದಿಗೆ ಸುರಕ್ಷಿತ ಹಾಗೂ ವಿಶ್ವಾಸಾರ್ಹ ಪ್ರಯಾಣ..",
  },
};
export default kn; 